import {useSyncExternalStore} from 'react'

export interface SettingsMobileState {
  /** A Settings page covers the home list; false shows the list. */
  isPageOpen: boolean
  /** How far the open page follows a back swipe, in px. */
  dragOffset: number
}

// The home list renders in the app's sidebar cell and each page in the
// route cell, so the phone navigation state lives outside both trees.
let state: SettingsMobileState = {isPageOpen: true, dragOffset: 0}
const listeners = new Set<() => void>()

function update(next: Partial<SettingsMobileState>): void {
  const merged = {...state, ...next}
  if (
    merged.isPageOpen === state.isPageOpen &&
    merged.dragOffset === state.dragOffset
  )
    return
  state = merged
  listeners.forEach(listener => listener())
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = (): SettingsMobileState => state

export const settingsMobileStore = {
  setPageOpen(isPageOpen: boolean): void {
    update({isPageOpen, dragOffset: 0})
  },
  setDragOffset(dragOffset: number): void {
    update({dragOffset})
  },
}

export function useSettingsMobileState(): SettingsMobileState {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
